import React, { useState } from "react";
import ResizableCell from "../../Utility/ResizableCell";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getUrlFromS3 } from "../api";
import useDownloader from "react-use-downloader";
import { toast } from "react-toastify";

export default function DiscountTable({ reports }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { download, isInProgress } = useDownloader();
  const [editableCell, setEditableCell] = useState(null);
  if (!reports || reports.length === 0) {
    return <p>No reports available</p>;
  }
  const oheaders = Object.keys(reports[0]).filter(
    (key) => key !== "_id" && key !== "report_id"
  );
  const desiredOrder = [
    "discount_name",
    "discount_type",
    "discount_amount",
    "report_date",
  ];

  // Filter the headers based on the desired order
  const headers = desiredOrder.filter((header) => oheaders.includes(header));

  const downloadHandler = async (restaurant_id, report_date, report_type) => {
    try {
      const response = await getUrlFromS3(
        restaurant_id,
        report_date,
        report_type
      );
      if (response?.file_url === undefined) {
        toast.error("File not available");
        return;
      }
      download(response.file_url, response.file_name);
    } catch (error) {
      toast.error("File not available");
    }
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="table table-striped table-hover table-bordered shadow-sm table-responsive table-stack">
        <thead>
          <tr>
            {headers.map((header) => (
              <th
                key={header}
                style={{
                  textAlign: "center",
                  textTransform: "capitalize",
                }}
              >
                <ResizableCell>{header}</ResizableCell>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {reports.map((row) => (
            <React.Fragment key={row.item_uuid}>
              <tr>
                {headers.map((header) => (
                  <td
                    data-label={header}
                    style={{
                      textAlign: "center",
                    }}
                    key={header}
                  >
                    {editableCell === row._id && header == "labor_category" ? (
                      <input
                        className="form-control mx-auto"
                        type="text"
                        defaultValue={row[header]}
                        onChange={(e) => {}}
                        style={{ width: "80%" }}
                      />
                    ) : header == "discount_name" ? (
                      <Link
                        to={`/restaurants/reports/report-details/${row.report_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-body"
                        style={{ textDecoration: "underline" }}
                      >
                        {row[header]}
                      </Link>
                    ) : typeof row[header] === "boolean" ? (
                      row[header] ? (
                        "Yes"
                      ) : (
                        "No"
                      )
                    ) : (
                      row[header]
                    )}
                  </td>
                ))}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
